const keyMirror = require('keymirror');

const SHIPPING_METHODS = keyMirror({
  PICK_UP: null,
  EXTERNAL_PICK_UP: null,
  FLASH: null,
  EXPRESS: null,
  SAME_DAY: null,
  SCHEDULED: null,
  STANDARD: null,
  NEXT_DAY: null,
  UNKNOWN: null,
  MANUAL: null,
  EXTERNAL_DELIVERY: null,
});

const SHIPPING_METHODS_LABEL_MAPPING = {
  [SHIPPING_METHODS.PICK_UP]: 'Pick up',
  [SHIPPING_METHODS.EXTERNAL_PICK_UP]: 'Pick up',
  [SHIPPING_METHODS.FLASH]: 'Express',
  [SHIPPING_METHODS.EXPRESS]: 'Express',
  [SHIPPING_METHODS.SAME_DAY]: 'Same day',
  [SHIPPING_METHODS.SCHEDULED]: 'Programado',
  [SHIPPING_METHODS.STANDARD]: 'Next Day',
  [SHIPPING_METHODS.NEXT_DAY]: 'Next Day',
  [SHIPPING_METHODS.UNKNOWN]: 'Desconocido',
  [SHIPPING_METHODS.MANUAL]: 'Coordinado',
  [SHIPPING_METHODS.EXTERNAL_DELIVERY]: 'Externo',
};

export { SHIPPING_METHODS, SHIPPING_METHODS_LABEL_MAPPING };
